// import { React, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./LearningLink.css";
// // import styles from '../../styles/LearningLink.module.css';
// import ResourceMain from "./ResourceMain";
// import Header from "../../../common/components/HeaderOpsPage/Header";
// import Sidebar from "../../../common/components/Main Menu/MainMenu";
// import Breadcrumb from "../../../common/components/NavigationBreadcrumb/Breadcrumb";
// import support_agent from "../../../assets/images/support_agent.png";
// import escalations from "../../../assets/images/escalations.png";
// import interaction from "../../../assets/images/interaction.png";
// import { useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import ContactCenter from "../../../operations/pages/OperationHome/ContactCenter";
// import learningLink from "../../../assets/images/learningLink.png";
// import TransactionPopup from "../MetricsCard/TransactionPopup";
// import { useDispatch } from "react-redux";
// import { fetchTransactionDetailsInit } from "../../../redux/slices/agentHomeSlice";

// const LearningLink = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const resource = location.state?.resource; // Get passed resource data
//   console.log("hell", resource);
//   const data = useSelector((state) => state?.agentHome?.performanceData);
//   console.log(data, "check");

//   const value = data?.strengthMessage?.detailedLearning?.learningResources;
//   console.log("deepika", value);

//   const totalCalls = data?.strengthMessage?.totalCalls;
//   console.log("totalCalls", totalCalls);

//   const escalaltion = data?.strengthMessage?.escalation;
//   console.log("escalaltion", escalaltion);

//   const affectedcallsCount = resource?.affectedCallIds.length || []; // Ensure it's an array
//   const affectedCallIds = resource?.affectedCallIds || [];
//   const affectedCallsLast24Hours = resource?.affectedCallsLast25Hours.length;
//   console.log("affectedcalls", affectedCallIds);
//   console.log("affectedCallsLast24Hours", affectedCallsLast24Hours);
//   const escalaltionCount = resource?.CallEscallation.length || [];

//   const [showTransactionPopup, setShowTransactionPopup] = useState(false);

//   const handleLinkClick = () => {
//     if (affectedCallIds?.length > 0) {
//       dispatch(fetchTransactionDetailsInit({ CallIds: affectedCallIds }));
//       setShowTransactionPopup(true);
//     }
//   };

//   const breadcrumbItems = [
//     { label: "Home", link: "/landing" },
//     { label: "Agent Home", link: "/agenthome" },
//     { label: "Learning Resource", link: "/agenthome" },
//     { label: resource?.title },
//   ];
//   return (
//     <>
//       {/* {loading && <Spinner loading={loading} />} */}
//       <div className="agent-main">
//         {/* <ContactCenter logoLink="/landing"/> */}
//         <div className="agent-app d-flex">
//           <div className="agent-header-container">
//             <ContactCenter logoLink="/landing" />
//           </div>
//           <div className="agent-main-container">
//             <Sidebar className="sidebar" />
//             <div className="agent-operations-home container-fluid">
//               <div className="my-3 ">
//                 <div className="learn-Learning-title">Learning Resource</div>
//                 <div className="learn-pathway">
//                   <Breadcrumb
//                     breadcrumbItems={breadcrumbItems}
//                     backLink="/AgentHome"
//                   />
//                 </div>
//                 <div className="learn-metrics-grid">
//                   <div className="learn-metric-box metric-left position-relative">
//                     <img
//                       src={learningLink}
//                       alt="link icon"
//                       className="learn-link-icon"
//                       onClick={handleLinkClick}
//                     />
//                     <div className="learn-metric-line"></div>{" "}
//                     {/* Blue vertical line */}
//                     <div className="learn-metric-content">
//                       <img
//                         src={support_agent}
//                         alt="Operations Home"
//                         className="learn-img"
//                       />
//                       <div>
//                         <span className="learn-metric-value">
//                           {affectedcallsCount ?? 0}/{totalCalls ?? 0}
//                         </span>
//                         {/* <br /> */}
//                         <span className="learn-metric-label">
//                           Interactions Affected
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="learn-metric-box metric-center position-relative">
//                     <img
//                       src={learningLink}
//                       alt="link icon"
//                       className="learn-link-icon"
//                     />
//                     <div className="learn-metric-line"></div>{" "}
//                     {/* Blue vertical line */}
//                     <div className="learn-metric-content">
//                       <img
//                         src={escalations}
//                         alt="Escalations"
//                         className="learn-img"
//                       />
//                       <div>
//                         <span className="learn-metric-value">
//                           {escalaltionCount ?? 0}/{totalCalls ?? 0}
//                         </span>
//                         {/* <br /> */}
//                         <span className="learn-metric-label">Escalations</span>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="learn-metric-box metric-right position-relative">
//                     <img
//                       src={learningLink}
//                       alt="link icon"
//                       className="learn-link-icon"
//                     />
//                     <div className="learn-metric-line"></div>{" "}
//                     {/* Blue vertical line */}
//                     <div className="learn-metric-content">
//                       <img
//                         src={interaction}
//                         alt="Last 24 Hrs"
//                         className="learn-img"
//                       />
//                       <div>
//                         <span className="learn-metric-value">
//                           {affectedCallsLast24Hours ?? 0}/{totalCalls ?? 0}
//                         </span>
//                         {/* <br /> */}
//                         <span className="learn-metric-label">
//                           Interactions Affected (
//                           <a href="#" className="learn-no-pointer">
//                             Last 24 Hrs
//                           </a>
//                           )
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="learn-mainContent">
//                 <ResourceMain />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* ✅ Transaction Popup */}
//       {showTransactionPopup && (
//         <TransactionPopup
//           isVisible={showTransactionPopup}
//           onClose={() => setShowTransactionPopup(false)}
//           recommendationCardTitle={resource?.title || "Interaction"}
//           affectedCallIds={affectedCallIds} // ✅ Pass filtered IDs
//         />
//       )}
//     </>
//   );
// };

// export default LearningLink;

// import { React, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./LearningLink.css";
// import ResourceMain from "./ResourceMain";
// import Header from "../../../common/components/HeaderOpsPage/Header";
// import Sidebar from "../../../common/components/Main Menu/MainMenu";
// import Breadcrumb from "../../../common/components/NavigationBreadcrumb/Breadcrumb";
// import support_agent from "../../../assets/images/support_agent.png";
// import escalations from "../../../assets/images/escalations.png";
// import interaction from "../../../assets/images/interaction.png";
// import { useSelector, useDispatch } from "react-redux";
// import { useLocation } from "react-router-dom";
// import ContactCenter from "../../../operations/pages/OperationHome/ContactCenter";
// import learningLink from "../../../assets/images/learningLink.png";
// import TransactionPopup from "../MetricsCard/TransactionPopup";
// import { fetchTransactionDetailsInit } from "../../../redux/slices/agentHomeSlice";

// const LearningLink = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const resource = location.state?.resource;

//   const data = useSelector((state) => state?.agentHome?.performanceData);
//   const value = data?.strengthMessage?.detailedLearning?.learningResources;
//   const totalCalls = data?.strengthMessage?.totalCalls;
//   const affectedCallIds = resource?.affectedCallIds || [];
//   const escalaltionCount = resource?.CallEscallation?.length || 0;
//   const affectedCallsLast24Hours =
//     resource?.affectedCallsLast25Hours?.length || 0;

//   const [showTransactionPopup, setShowTransactionPopup] = useState(false);
//   const [popupTitle, setPopupTitle] = useState("");
//   const [currentCallIds, setCurrentCallIds] = useState([]);

//   const handleLinkClick = (type) => {
//     let callIdsToFetch = [];
//     let title = "Interaction";

//     switch (type) {
//       case "affected":
//         callIdsToFetch = affectedCallIds;
//         title = "Affected Interactions";
//         break;
//       case "escalations":
//         callIdsToFetch = resource?.CallEscallation || [];
//         title = "Escalations";
//         break;
//       case "last24hrs":
//         callIdsToFetch = resource?.affectedCallsLast25Hours || [];
//         title = "Last 24 Hrs Interactions";
//         break;
//       default:
//         return;
//     }

//     if (callIdsToFetch.length > 0) {
//       dispatch(fetchTransactionDetailsInit({ CallIds: callIdsToFetch }));
//       setCurrentCallIds(callIdsToFetch);
//       setPopupTitle(title);
//       setShowTransactionPopup(true);
//     }
//   };

//   const breadcrumbItems = [
//     { label: "Home", link: "/landing" },
//     { label: "Agent Home", link: "/agenthome" },
//     { label: "Learning Resource", link: "/agenthome" },
//     { label: resource?.title },
//   ];

//   return (
//     <>
//       <div className="agent-main">
//         <div className="agent-app d-flex">
//           <div className="agent-header-container">
//             <ContactCenter logoLink="/landing" />
//           </div>
//           <div className="agent-main-container">
//             <Sidebar className="sidebar" />
//             <div className="agent-operations-home container-fluid">
//               <div className="my-3">
//                 <div className="learn-Learning-title">Learning Resource</div>
//                 <div className="learn-pathway">
//                   <Breadcrumb
//                     breadcrumbItems={breadcrumbItems}
//                     backLink="/AgentHome"
//                   />
//                 </div>

//                 <div className="learn-metrics-grid">
//                   {/* Affected Interactions */}
//                   <div className="learn-metric-box metric-left position-relative">
//                     <img
//                       src={learningLink}
//                       alt="link icon"
//                       className="learn-link-icon"
//                       onClick={() => handleLinkClick("affected")}
//                     />
//                     <div className="learn-metric-line"></div>
//                     <div className="learn-metric-content">
//                       <img
//                         src={support_agent}
//                         alt="Operations Home"
//                         className="learn-img"
//                       />
//                       <div>
//                         <span className="learn-metric-value">
//                           {affectedCallIds.length ?? 0}/{totalCalls ?? 0}
//                         </span>
//                         <span className="learn-metric-label">
//                           Interactions Affected
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Escalations */}
//                   <div className="learn-metric-box metric-center position-relative">
//                     <img
//                       src={learningLink}
//                       alt="link icon"
//                       className="learn-link-icon"
//                       onClick={() => handleLinkClick("escalations")}
//                     />
//                     <div className="learn-metric-line"></div>
//                     <div className="learn-metric-content">
//                       <img
//                         src={escalations}
//                         alt="Escalations"
//                         className="learn-img"
//                       />
//                       <div>
//                         <span className="learn-metric-value">
//                           {escalaltionCount ?? 0}/{totalCalls ?? 0}
//                         </span>
//                         <span className="learn-metric-label">Escalations</span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Last 24 Hrs Affected */}
//                   <div className="learn-metric-box metric-right position-relative">
//                     <img
//                       src={learningLink}
//                       alt="link icon"
//                       className="learn-link-icon"
//                       onClick={() => handleLinkClick("last24hrs")}
//                     />
//                     <div className="learn-metric-line"></div>
//                     <div className="learn-metric-content">
//                       <img
//                         src={interaction}
//                         alt="Last 24 Hrs"
//                         className="learn-img"
//                       />
//                       <div>
//                         <span className="learn-metric-value">
//                           {affectedCallsLast24Hours ?? 0}/{totalCalls ?? 0}
//                         </span>
//                         <span className="learn-metric-label">
//                           Interactions Affected (
//                           <a href="#" className="learn-no-pointer">
//                             Last 24 Hrs
//                           </a>
//                           )
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="learn-mainContent">
//                 <ResourceMain />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Transaction Popup */}
//       {showTransactionPopup && (
//         <TransactionPopup
//           isVisible={showTransactionPopup}
//           onClose={() => setShowTransactionPopup(false)}
//           recommendationCardTitle={popupTitle}
//           affectedCallIds={currentCallIds}
//         />
//       )}
//     </>
//   );
// };

// export default LearningLink;

import { React, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LearningLink.css";
import ResourceMain from "./ResourceMain";
// import Header from "../../../common/components/HeaderOpsPage/Header";
import Navbar from "../../../common/components/HeaderOpsPage/Navbar";

import Sidebar from "../../../common/components/Main Menu/MainMenu";
import Breadcrumb from "../../../common/components/NavigationBreadcrumb/Breadcrumb";
import support_agent from "../../../assets/images/support_agent.png";
import escalations from "../../../assets/images/escalations.png";
import interaction from "../../../assets/images/interaction.png";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ContactCenter from "../../../operations/pages/OperationHome/ContactCenter";
import learningLink from "../../../assets/images/learningLink.png";
import TransactionPopup from "../MetricsCard/TransactionPopup";
import { fetchTransactionDetailsInit } from "../../../redux/slices/agentHomeSlice";

const LearningLink = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const resource = location.state?.resource;

  const data = useSelector((state) => state?.agentHome?.performanceData);
  const totalCalls = data?.strengthMessage?.totalCalls;

  const affectedCallIds = resource?.affectedCallIds || [];
  const escalaltionCallIds = resource?.CallEscallation || [];
  const affectedCallsLast24HoursIds = resource?.affectedCallsLast25Hours || [];

  const [showTransactionPopup, setShowTransactionPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [currentCallIds, setCurrentCallIds] = useState([]);

  const handleLinkClick = (type) => {
    let callIdsToFetch = [];
    let title = "Interaction";

    switch (type) {
      case "affected":
        callIdsToFetch = affectedCallIds;
        title = "Affected Interactions";
        break;
      case "escalations":
        callIdsToFetch = escalaltionCallIds;
        title = "Escalations";
        break;
      case "last24hrs":
        callIdsToFetch = affectedCallsLast24HoursIds;
        title = "Last 24 Hrs Interactions";
        break;
      default:
        return;
    }

    if (callIdsToFetch.length > 0) {
      dispatch(fetchTransactionDetailsInit({ CallIds: callIdsToFetch }));
      setCurrentCallIds(callIdsToFetch);
      setPopupTitle(title);
      setShowTransactionPopup(true);
    }
  };

  const breadcrumbItems = [
    { label: "Home", link: "/landing" },
    { label: "Agent Home", link: "/agenthome" },
    { label: "Learning Resource", link: "/agenthome" },
    { label: resource?.title },
  ];

  return (
    <>
      <div className="agent-main">
        <div className="agent-app d-flex">
          <div className="agent-header-container">
            {/* <ContactCenter logoLink="/landing" /> */}
            <Navbar/>
          </div>
          <div className="agent-main-container">
            {/* <Sidebar className="sidebar" /> */}
            <div className="agent-operations-home learning-container container-fluid">
              <div className="my-3">
                <div className="learn-Learning-title">Learning Resource</div>
                <div className="learn-pathway">
                  <Breadcrumb
                    breadcrumbItems={breadcrumbItems}
                    backLink="/AgentHome"
                  />
                </div>

                <div className="learn-metrics-grid">
                  {/* Affected Interactions */}
                  <div className="learn-metric-box metric-left position-relative">
                    <img
                      src={learningLink}
                      alt="link icon"
                      className={`learn-link-icon ${
                        affectedCallIds.length === 0 ? "disabled-icon" : ""
                      }`}
                      onClick={() =>
                        affectedCallIds.length > 0 &&
                        handleLinkClick("affected")
                      }
                    />
                    <div className="learn-metric-line"></div>
                    <div className="learn-metric-content">
                      <img
                        src={support_agent}
                        alt="Operations Home"
                        className="learn-img"
                      />
                      <div>
                        <span className="learn-metric-value">
                          {affectedCallIds.length ?? 0}/{totalCalls ?? 0}
                        </span>
                        <span className="learn-metric-label">
                          Interactions Affected
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Escalations */}
                  <div className="learn-metric-box metric-center position-relative">
                    <img
                      src={learningLink}
                      alt="link icon"
                      className={`learn-link-icon ${
                        escalaltionCallIds.length === 0 ? "disabled-icon" : ""
                      }`}
                      onClick={() =>
                        escalaltionCallIds.length > 0 &&
                        handleLinkClick("escalations")
                      }
                    />
                    <div className="learn-metric-line"></div>
                    <div className="learn-metric-content">
                      <img
                        src={escalations}
                        alt="Escalations"
                        className="learn-img"
                      />
                      <div>
                        <span className="learn-metric-value">
                          {escalaltionCallIds.length ?? 0}/{totalCalls ?? 0}
                        </span>
                        <span className="learn-metric-label">Escalations</span>
                      </div>
                    </div>
                  </div>

                  {/* Last 24 Hrs Interactions */}
                  <div className="learn-metric-box metric-right position-relative">
                    <img
                      src={learningLink}
                      alt="link icon"
                      className={`learn-link-icon ${
                        affectedCallsLast24HoursIds.length === 0
                          ? "disabled-icon"
                          : ""
                      }`}
                      onClick={() =>
                        affectedCallsLast24HoursIds.length > 0 &&
                        handleLinkClick("last24hrs")
                      }
                    />
                    <div className="learn-metric-line"></div>
                    <div className="learn-metric-content">
                      <img
                        src={interaction}
                        alt="Last 24 Hrs"
                        className="learn-img"
                      />
                      <div>
                        <span className="learn-metric-value">
                          {affectedCallsLast24HoursIds.length ?? 0}/
                          {totalCalls ?? 0}
                        </span>
                        <span className="learn-metric-label">
                          Interactions Affected (
                          <a href="#" className="learn-no-pointer">
                            Last 24 Hrs
                          </a>
                          )
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="learn-mainContent">
                <ResourceMain />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Transaction Popup */}
      {showTransactionPopup && (
        <TransactionPopup
          isVisible={showTransactionPopup}
          onClose={() => setShowTransactionPopup(false)}
          recommendationCardTitle={popupTitle}
          affectedCallIds={currentCallIds}
        />
      )}
    </>
  );
};

export default LearningLink;
